import { DimensionValue } from "react-native";

export type StatusScreenScaffoldProps = {
  title: string;
  subtitle: string;
  type: StatusScreenType;
  subtitleMaxWidth?: DimensionValue | string;
};

export enum StatusScreenType {
  success = "success",
  error = "error",
  info = "info",
}
